import { createFileRoute } from '@tanstack/react-router';

import { TagSectionModal } from '../../../../-components/SectionModal/TagSectionModal';

export const Route = createFileRoute('/_authenticated/placement/$tenantId/tag/$tagId/sections/new')(
    {
        component: TagSectionModal,
    },
);
